import React from 'react'
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from '@react-pdf/renderer'
import moment, { Moment } from 'moment'
import * as Datetime from 'react-datetime'
import { IActiveTripResponseV2, IDailyTripLogReq, ITripStatusesObj } from 'src/types'
import Select from 'react-select'

interface IAccess2CareTripLogPDFProps {
  dailyTripLogs: any[]
  getDailyTripLogs: (params: IDailyTripLogReq) => any
}

interface ISelectOption {
  label: string
  value: any
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row'
  },
  headerTop: {
    flexDirection: 'row',
    marginBottom: 10
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: '100'
  },
  headerLeftInfo: {
    width: '50%',
    paddingLeft: 10
  },
  headerRightInfo: {
    width: '50%',
    paddingRight: 10
  },
  headerData: {
    fontSize: '12',
    borderBottom: '1px solid black',
    paddingBottom: 2
  },
  headerCaption: {
    fontSize: 8
  },
  section: {
    marginLeft: 10,
    marginTop: 20,
    padding: 10,
    flexGrow: 1,
    fontSize: 14
    // fontWeight:
  },

  font: {
    fontSize: 10,
    marginRight: 20,
    marginTop: 20
  },

  /* Table */
  table: {
    fontSize: 10,
    width: 1000,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignContent: 'stretch',
    flexWrap: 'nowrap',
    alignItems: 'stretch'
  },
  row: {
    // display: 'flex',
    flexDirection: 'row'
    // justifyContent: 'space-around',
    // alignContent: 'stretch',
    // flexWrap: 'nowrap',
    // alignItems: 'stretch',
    // flexGrow: 0,
    // flexShrink: 0,
    // flexBasis: 35
  },
  cell: {
    /* borderColor: 'black',
    borderStyle: 'solid',
    borderWidth: 1, */
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    alignSelf: 'stretch',
    fontSize: 10
    /* marginLeft: 20,
    marginRight:20 */
  },
  header: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black'
  },
  headerText: {
    fontSize: 11,
    color: 'black',
    verticalAlign: 'middle'
  },
  tableText: {
    margin: 10,
    marginLeft: 10,
    fontSize: 10,
    color: 'black'
  },
  body: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20
  },
  image: {
    height: 18,
    width: 40
  },
  imageSignature: {
    marginTop: -16,
    height: 32,
    width: 40
  },
  headerOneLine: {
    textAlign: 'center',
    borderLeft: '1px solid black',
    minHeight: '2.5em',
    padding: '10 5'
  },
  headerTwoLines: {
    textAlign: 'center',
    borderLeft: '1px solid black',
    minHeight: '2.5em',
    padding: 5
  },
  dataLine: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    minHeight: '1.2em',
    fontSize: 10,
    paddingVertical: 5,
    paddingLeft: 5,
    paddingRight: 5
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20
  }
  /* Table */
})

const devOptions = [
  { label: 'A-PPE', value: '34286a1f-073e-40e4-a8d1-5eb60c71e638' },
  { label: 'A', value: 'd8fbf4eb-8336-4003-bead-d883bea7ab92' }
]

const prodOptions = [
  { label: 'A-PPE', value: '713c6ea1-4061-42e0-a998-bc1318eb6a96' },
  { label: 'A', value: 'c7fe57c1-53f3-4fbc-a73e-3355b16349ba' },
  { label: 'WC-PPE', value: 'd6c1eaf3-ced2-462b-8b16-b38159ba0fe9' },
  { label: 'WC', value: 'ec7df0cd-3ee4-4dee-8226-60a94735b6fd' }
]

const options = process.env.REACT_APP_ENV === 'production' ? prodOptions : devOptions
// below code is for local testing
// const options = [
//   { label: 'A-PPE', value: '34286a1f-073e-40e4-a8d1-5eb60c71e638' }
// ]
const serviceId =
  process.env.REACT_APP_ENV === 'production'
    ? 'c41dd970-9bcc-454f-a3ff-488bfba6097a'
    : '28d8a4f0-fce5-4010-8790-212f4cfe4098'
// below code is for local testing
// const serviceId = '28d8a4f0-fce5-4010-8790-212f4cfe4098'

export const Access2CareTripLogPDF = (props: IAccess2CareTripLogPDFProps) => {
  const [fromDateFilter, setFromDate] = React.useState(
    moment()
      .startOf('day')
      .subtract(7, 'days')
      .toISOString()
  )
  const [toDateFilter, setToDate] = React.useState(
    moment()
      .endOf('day')
      .toISOString()
  )
  const [filterMessage, setFilterMessage] = React.useState('')
  const [fromDateDisplay, setFromDateDisplay] = React.useState(
    moment()
      .startOf('day')
      .subtract(7, 'days')
      .format('MM/DD/YYYY hh:mmA')
  )
  const [toDateDisplay, setToDateDisplay] = React.useState(
    moment()
      .endOf('day')
      .format('MM/DD/YYYY hh:mmA')
  )
  const [productIds, setProductId] = React.useState([options[0].value])
  const filename = `Access2CareTripLog-${moment().format('YYYY-MM-DD HH:MM:SS')}`

  const setFromDateFilter = (e: Moment) => {
    if (moment(e).isValid()) {
      const fromDate = e.startOf('day')
      const fromDateISO = fromDate.toISOString()
      const toDate = moment(toDateFilter).endOf('day')

      if (fromDate > toDate) {
        setFilterMessage(`Please choose a earlier date than ${toDateDisplay}`)

        return
      } else {
        setFilterMessage('')
      }
      setFromDate(fromDateISO)
      setToDate(toDate.toISOString())
      setFromDateDisplay(fromDate.format('MM/DD/YYYY hh:mmA'))
      setToDateDisplay(toDate.format('MM/DD/YYYY hh:mmA'))
    }
  }
  const setToDateFilter = (e: Moment) => {
    if (moment(e).isValid()) {
      const toDate = e.endOf('day')
      const toDateISO = toDate.toISOString()
      const fromDate = moment(fromDateFilter).startOf('day')

      if (fromDate > toDate) {
        setFilterMessage(`Please choose a later date ${fromDateDisplay}`)
        return
      } else {
        setFilterMessage('')
      }
      setFromDate(fromDate.toISOString())
      setToDate(toDateISO)
      setFromDateDisplay(fromDate.format('MM/DD/YYYY hh:mmA'))
      setToDateDisplay(toDate.format('MM/DD/YYYY hh:mmA'))
    }
  }

  const convertToMiles = (meters: number) => {
    return Math.round(meters / 1609.344)
  }
  const getVehiclePLates = (trips: IActiveTripResponseV2[]) => {
    const liscenePlates = Array.from(
      new Set(
        trips.map((trip: IActiveTripResponseV2) => {
          if (trip.vehicle && trip.vehicle.licensePlate.length > 0) {
            return trip.vehicle.licensePlate
          }
          return ''
        })
      )
    ).join(',')
    return liscenePlates
  }

  const selectProductIds = (selectedIds: ISelectOption[]) => {
    let productIds = []
    if (selectedIds) {
      productIds = selectedIds.map((op: any) => op.value)
    }
    setProductId(productIds)
  }

  const devCheckAWS = (id: string | undefined) => {
    if (id) {
      switch (id) {
        case options[0].value: {
          return 'A-PPE'
        }
        case options[1].value: {
          return 'A'
        }
        default:
          return ''
      }
    }
    return ''
  }
  const prodheckAWS = (id: string | undefined) => {
    if (id) {
      switch (id) {
        case options[0].value: {
          return 'A-PPE'
        }
        case options[1].value: {
          return 'A'
        }
        case options[2].value: {
          return 'WC-PPE'
        }
        case options[3].value: {
          return 'WC'
        }
        default:
          return ''
      }
    }
    return ''
  }
  const checkAWS = process.env.REACT_APP_ENV === 'production' ? prodheckAWS : devCheckAWS

  const getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }
  const getTime = (date: string | undefined, dateFormat: string = 'hh:mm A'): string | null => {
    const initDate = moment(date)
    return initDate.isValid() ? initDate.format(dateFormat) : null
  }
  const getStatusDateTime = (
    statuses: ITripStatusesObj[],
    shouldStatusContainOne: number[],
    dateFormat: string = 'hh:mm A'
  ): string | null => {
    const stats = statuses.find(status => {
      return shouldStatusContainOne.find(n => status.statusId === n)
    })
    if (stats) {
      return getTime(stats.createdAt, dateFormat)
    }
    return null
  }
  const Access2CareTripLog = (props: any) => {
    let totalAPPE: number = 0
    let totalA: number = 0
    let totalWCPEE: number = 0
    let totalWC: number = 0

    if (props.dailyTripsLog) {
      return (
        <Document>
          {props.dailyTripsLog.map((item: any) => {
            const date = Object.keys(item)[0]
            const driverId = Object.keys(item[date])[0]
            const tripLogs = item[date][driverId]
            const operator = tripLogs[0].operator
            const driverName = `${tripLogs[0].operator.firstName} ${tripLogs[0].operator.lastName}`
            const repName = tripLogs[0].representativeName
            const repSignature =
              tripLogs[0].representativeSignature !== '' && tripLogs[0].representativeSignature !== null
                ? `https://${getBucketName()}.s3.amazonaws.com/uploads/signatures/rep/${tripLogs[0].driverSignature}`
                : ''

            const liscensePlates = getVehiclePLates(tripLogs)

            totalAPPE = 0
            totalA = 0
            totalWCPEE = 0
            totalWC = 0
            const logs = tripLogs.reduce(
              (r: any[][], e: any, i: number) => (i % 8 ? r[r.length - 1].push(e) : r.push([e])) && r,
              []
            )
            console.log('Logs: ', logs)
            return logs.map((tripLog: any, logIndex: number) => {
              return (
                <Page size='A4' style={styles.body} wrap={false} key={date + `-${logIndex}`} orientation='landscape'>
                  {/* Headers */}
                  <View style={styles.headerTop}>
                    <div style={{ width: '20%' }}>
                      <div style={styles.row}>
                        <Text style={{ fontSize: '22' }}>Access2Care</Text>
                      </div>
                    </div>
                    <div style={{ width: '80%' }}>
                      <Text style={[styles.headerTitle]}>WASHINGTON DAILY TRIP LOG</Text>
                    </div>
                  </View>
                  <View style={[styles.row, { marginBottom: 20 }]}>
                    <View style={{ width: '70%', flexDirection: 'column' }}>
                      <View style={[styles.row, { textAlign: 'center' }]}>
                        <div style={styles.headerRightInfo}>
                          <Text style={styles.headerData}>Medstar</Text>
                          <Text style={styles.headerCaption}>Provider Name</Text>
                        </div>
                        <div style={styles.headerLeftInfo}>
                          <Text style={styles.headerData}>
                            {fromDateDisplay.substring(0, 10)} - {toDateDisplay.substring(0, 10)}
                          </Text>
                          <Text style={styles.headerCaption}>Date Range</Text>
                        </div>
                      </View>
                      <View style={[styles.row, { textAlign: 'center', marginTop: 5 }]}>
                        <div style={styles.headerRightInfo}>
                          <Text style={styles.headerData}>{driverName}</Text>
                          <Text style={styles.headerCaption}>Driver's Name (as it appears on drivers license)</Text>
                        </div>
                        <div style={styles.headerLeftInfo}>
                          <Text style={styles.headerData}>
                            {' ' + liscensePlates} {`_ ${operator.driversLicense || ''}`}
                          </Text>
                          <Text style={styles.headerCaption}>Vehicle Number (Last six of the VIN)</Text>
                        </div>
                      </View>
                    </View>
                    <View style={[styles.row, { width: '30%' }]}>
                      <div style={{ fontSize: 9, paddingLeft: 40 }}>
                        <Text>Mail invoices to:</Text>
                      </div>
                    </View>
                  </View>
                  {/* Headers */}

                  {/* Table Body */}

                  <View style={[styles.row, styles.header, styles.headerText]}>
                    <View style={[styles.headerOneLine, { width: '8%' }]}>
                      <Text>Date</Text>
                    </View>
                    <View style={[styles.headerTwoLines, { width: '8%' }]}>
                      <Text>Trip ID</Text>
                    </View>
                    <View style={[styles.headerOneLine, { width: '20%' }]}>
                      <Text>Recipient's Name</Text>
                    </View>
                    <View style={[styles.headerOneLine, { width: '4.5%' }]}>
                      <Text>AWS</Text>
                    </View>
                    <View style={[styles.headerTwoLines, { width: '8%' }]}>
                      <Text>Pick-UP Time</Text>
                    </View>
                    <View style={[styles.headerTwoLines, { width: '8%' }]}>
                      <Text>Drop-Off Time</Text>
                    </View>
                    <View style={[styles.headerTwoLines, { width: '7.5%' }]}>
                      <Text>Scheduled Time</Text>
                    </View>
                    <View style={[styles.headerTwoLines, { width: '8%' }]}>
                      <Text>Total Mileage</Text>
                    </View>
                    <View style={[styles.headerOneLine, { width: '8%' }]}>
                      <Text>Amount</Text>
                    </View>
                    <View style={[styles.headerOneLine, { width: '20%', borderRight: '1px solid black' }]}>
                      <Text>Signature</Text>
                    </View>
                  </View>
                  {console.log(`tripLog: ${logIndex}`, tripLog)}
                  {tripLog.map((trip: IActiveTripResponseV2, operatorLogIndex: number) => {
                    console.log(`trip: ${operatorLogIndex}`, trip)
                    // const imageHash = crypto.SHA256(trip.id).toString()
                    const details: { billingCode: string; originalPickAddr: string; originalDropAddr: string } =
                      trip.details
                    const billingCode: string = details && details.billingCode !== null ? details.billingCode : ''
                    const awsCode = checkAWS(trip.product.productId)
                    const distance = trip.estimatedDistance > 0 ? trip.estimatedDistance : trip.distance
                    console.log('awsCode: ' + awsCode)
                    switch (awsCode) {
                      case 'A-PPE': {
                        totalAPPE = totalAPPE + 1
                        break
                      }
                      case 'A': {
                        totalA = totalA + 1
                        break
                      }
                      case 'WC-PPE': {
                        totalWCPEE = totalWCPEE + 1
                        break
                      }
                      case 'WC': {
                        totalWC = totalWC + 1
                        break
                      }
                    }

                    return (
                      <View style={[styles.row]} key={trip.id}>
                        <View style={[styles.dataLine, { width: '8%', textAlign: 'center' }]}>
                          <Text> {getStatusDateTime(trip.status, [5], 'MM/DD/YYYY')}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '8%', textAlign: 'center' }]}>
                          <Text />
                        </View>
                        <View style={[styles.dataLine, { width: '20%' }]}>
                          <Text key={trip.id}>
                            {trip.rider.firstName} {trip.rider.lastName}
                          </Text>
                        </View>
                        <View style={[styles.dataLine, { width: '4.5%', textAlign: 'center' }]}>
                          <Text>{awsCode}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '8%', textAlign: 'center' }]}>
                          <Text> {getStatusDateTime(trip.status, [5, 9])}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '8%', textAlign: 'center' }]}>
                          <Text> {getStatusDateTime(trip.status, [7, 8, 9])}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '7.65%', textAlign: 'center' }]}>
                          <Text> {getStatusDateTime(trip.status, [5])}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '8%', textAlign: 'center' }]}>
                          <Text>{convertToMiles(distance)}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '8%', textAlign: 'center' }]}>
                          <Text>{trip.estimatedPrice}</Text>
                        </View>
                        <View style={[styles.dataLine, { width: '20%', borderRight: '1px solid black' }]}>
                          <div style={{ paddingLeft: 30 }}>
                            {trip.riderSignature !== '' && (
                              <Image
                                style={styles.image}
                                src={`https://${getBucketName()}.s3.amazonaws.com/uploads/signatures/rider/${
                                  trip.riderSignature
                                }`}
                                cache={true}
                              />
                            )}
                          </div>
                        </View>
                      </View>
                    )
                  })}
                  {/* Table Body */}

                  {/* Footers */}
                  <View style={styles.footer}>
                    <View style={{ flexDirection: 'row' }}>
                      <Text style={{ fontSize: '10' }}>
                        *NOTE** Leg of transport-a leg of transport is the point of pick-up to the destination Example:
                        Picking recipient up at residence and transporting to the doctor's office would be considered
                        one leg picking the recipient up at the doctor's office and transporting back to the residence
                        would be considered the second leg of the trp Each leg of the transport must be documented on
                        separate lines. A signature is required for each leg of the transport Pick-up and drop-off times
                        must be documented and in military time.
                      </Text>
                      <Text>{'\n'}</Text>
                      <Text>{'\n'}</Text>
                    </View>

                    <View style={{ flexDirection: 'row', marginTop: 20 }}>
                      <Text style={{ fontSize: '11' }}>
                        Drivers Comments: __________________________________________________________________________
                      </Text>
                      <Text>{'\n'}</Text>
                    </View>

                    <View style={{ flexDirection: 'row' }}>
                      <Text style={{ fontSize: '10' }}>
                        I understand that Access2care, LLC will verify the accuracy of the mileage being reported and I
                        hereby certify the information herein is true, correct, and accurate.
                      </Text>
                      <Text>{'\n'}</Text>
                      <Text>{'\n'}</Text>
                    </View>

                    <View style={{ flexDirection: 'row', marginTop: 20 }}>
                      <View style={{ width: '30%', flexDirection: 'column' }}>
                        <Text style={{ fontSize: '11' }}>Driver Name: {driverName} </Text>
                      </View>
                      <View style={{ width: '35%', flexDirection: 'column', textAlign: 'center' }}>
                        <Text style={{ fontSize: '11' }}>Representative Name: {repName}</Text>
                      </View>
                      <View style={{ width: '20%', flexDirection: 'column', textAlign: 'center' }}>
                        <Text style={{ fontSize: '11' }}>Representative Signature:</Text>
                      </View>
                      <View style={{ width: '15%', flexDirection: 'column', textAlign: 'left' }}>
                        {repSignature !== '' && <Image style={styles.imageSignature} src={repSignature} cache={true} />}
                      </View>
                    </View>

                    <View
                      style={{
                        flexDirection: 'row',
                        marginTop: 20,
                        display: 'flex',
                        justifyContent: 'space-around',
                        fontSize: '11'
                      }}
                    >
                      <View>
                        <Text>A-PPE - {totalAPPE}</Text>
                      </View>
                      <View>
                        <Text>A - {totalA}</Text>
                      </View>
                      <View>
                        <Text>WC-PPE - {totalWCPEE}</Text>
                      </View>
                      <View>
                        <Text>WC - {totalWC}</Text>
                      </View>
                    </View>
                  </View>
                  {/* Footers */}
                </Page>
              )
            })
          })}
        </Document>
      )
    }
    return <div />
  }

  React.useEffect(() => {
    props.getDailyTripLogs({
      serviceId,
      fromDate: fromDateFilter,
      toDate: toDateFilter,
      productIds,
      statusGroup: 'completed'
    })
  }, [fromDateFilter, toDateFilter, productIds])

  return (
    <div>
      <label className='ml1 h5 font-red'>{filterMessage}</label>
      <div className='flex mb2'>
        <div className='ml1 col-2'>
          <label className='h5'>From</label>
          <Datetime className='mt1 datepickerStyle' value={fromDateDisplay} onChange={setFromDateFilter} />
        </div>
        <div className='ml1 col-2'>
          <label className='h5'>To</label>
          <Datetime className='mt1 datepickerStyle' value={toDateDisplay} onChange={setToDateFilter} />
        </div>
        <div className='ml1 col-2'>
          <label className='h5'>Select Product</label>
          <Select
            classNamePrefix='select-control'
            options={options}
            value={options.filter((op: any) => productIds.includes(op.value))}
            onChange={selectProductIds}
            isMulti={true}
          />
        </div>
      </div>
      {props.dailyTripLogs && props.dailyTripLogs.length && props.dailyTripLogs.length > 0 ? (
        <PDFDownloadLink document={<Access2CareTripLog dailyTripsLog={props.dailyTripLogs} />} fileName={filename}>
          {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
        </PDFDownloadLink>
      ) : (
        <div>No trip data</div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/services/view/pdfs/Access2CareTripLogPDF.tsx